.cc-wrapper {
  text-align: initial;
}

.cc-body {
  height: calc(100vh - 115px);
  overflow: auto;
  position: relative;
}

.cc-header {
  position: sticky;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
}

@media screen and (min-width: 980px) {
  .cc-header--content-scrollable::after {
    content: "";
    position: absolute;
    right: 0;
    left: 0;
    bottom: -10px;
    height: 10px;
    background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
    opacity: 0;
    pointer-events: none;
  }
}

@media screen and (min-width: 980px) {
  .cc-header--content-scrolled::after {
    opacity: 1;
  }
}

@media screen and (min-width: 980px) {
  .cc-header {
    position: sticky;
    padding: 24px 36px;
    top: 0;
    flex-direction: column;
    z-index: 1000;
    background-color: #ffffff;
  }
}

.cc-header__info-wrapper {
  display: flex;
  color: #333333;
}

@media screen and (min-width: 980px) {
  .cc-header__info-wrapper {
    border-bottom: 1px solid var(--qds-theme-divider-standard);
    padding-bottom: 24px;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .cc-header__info-wrapper [dir=rtl] {
    margin-left: 24px;
    margin-right: 0px;
  }

  :host([dir="rtl"]) .cc-header__info-wrapper [dir=rtl] {
    margin-right: 24px;
    margin-left: 0px;
  }
}

.cc-header__info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.cc-header__info-divider {
  height: 1px;
  padding: 0 36px;
  border-bottom: 1px solid black;
}

.cc-header__info-title {
  margin-bottom: 4px;
  font-size: 14px;
  line-height: 24px;
  font-weight: bold;
}

@media screen and (min-width: 980px) {
  .cc-header__info-title {
    font-size: 24px;
  }
}

.cc-header__info-description {
  font-size: 12px;
  line-height: 16px;
  max-width: 415px;
}

@media screen and (min-width: 980px) {
  .cc-header__info-description {
    font-size: 14px;
    line-height: 20px;
  }
}

:host(:not([dir="rtl"])) .cc-header__img {
  margin-right: 16px;
}

:host([dir="rtl"]) .cc-header__img {
  margin-left: 16px;
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .cc-header__img {
    margin-right: 36px;
  }

  :host([dir="rtl"]) .cc-header__img {
    margin-left: 36px;
  }
}

.cc-header__img img {
  width: 100px;
  height: 100px;
}

@media screen and (min-width: 980px) {
  .cc-header__img img {
    width: 115px;
    height: 115px;
  }
}

.cc-header__chips {
  margin-top: 24px;
}

.cc-header__chips-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

:host(:not([dir="rtl"])) .cc-header__chips-title {
  margin-left: 4px;
}

:host([dir="rtl"]) .cc-header__chips-title {
  margin-right: 4px;
}

.cc-header__search-slot {
  width: 100%;
}

@media screen and (min-width: 980px) {
  .cc-header__search-slot {
    width: 50%;
    flex-basis: 50%;
  }

  :host(:not([dir="rtl"])) .cc-header__search-slot {
    margin-left: 6px;
  }

  :host([dir="rtl"]) .cc-header__search-slot {
    margin-right: 6px;
  }
}

.cc-header__search-block {
  display: flex;
  margin-top: 8px;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}

@media screen and (min-width: 980px) {
  .cc-header__search-block {
    flex-direction: row;
  }
}

.cc-header .cc-content__search-info-message-wrapper {
  width: 100%;
}

@media screen and (min-width: 980px) {
  .cc-header .cc-content__search-info-message-wrapper {
    width: 50%;
  }
}

.cc-header__result-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin-top: 24px;
}

.cc-content__notification-wrapper {
  width: 100%;
  font-size: 14px;
}

@media screen and (min-width: 980px) {
  .cc-content__notification-wrapper {
    width: 50%;
  }
}

.cc-content__result-title {
  padding: 8px 16px;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: #333333;
}

@media screen and (min-width: 980px) {
  .cc-content__result-title {
    padding: 8px 0;
  }
}

.cc-content__result-title:not(:first-child) {
  padding-top: 36px;
}

@media screen and (min-width: 980px) {
  .cc-content__result-title:not(:first-child) {
    padding-top: 24px;
  }
}

@media screen and (min-width: 980px) {
  .cc-content__result-wrapper {
    padding: 0 36px 24px;
  }
}

.cc-content__result--no-result {
  padding: 24px 36px 48px;
}

.cc-content__loading-wrapper {
  position: absolute;
  bottom: 35%;
}

:host(:not([dir="rtl"])) .cc-content__loading-wrapper {
  left: 50%;
}

:host([dir="rtl"]) .cc-content__loading-wrapper {
  right: 50%;
}

@media screen and (min-width: 980px) {
  .cc-content__loading-wrapper {
    bottom: 15%;
  }
}